import React from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import MessageInput from './shared/MessageInput';

/**
 * Channel message input component
 * @param {string} value - Current input value
 * @param {Function} onChange - Handler for input changes
 * @param {Function} onSend - Handler for sending message
 * @param {boolean} sending - Whether message is being sent
 * @param {string} channelName - Name of the current channel
 */
const ChannelInput = ({ value, onChange, onSend, sending, channelName }) => {
  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
      <form onSubmit={(e) => { e.preventDefault(); onSend(); }} className="space-y-2">
        <div className="flex items-end gap-3" style={{ flexWrap: 'nowrap' }}>
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                onSend();
              }
            }}
            placeholder={`Message #${channelName}`}
            rows={2}
            disabled={sending}
            className="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            style={{ minHeight: '3.5rem', lineHeight: '1.5', boxSizing: 'border-box', flex: '1 1 auto', minWidth: 0 }}
          />
          <button
            type="submit"
            disabled={!value.trim() || sending}
            className="bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
            style={{ 
              height: '3.625rem', 
              minHeight: '3.625rem', 
              width: '3.5rem', 
              minWidth: '3.5rem',
              flexShrink: 0,
              boxSizing: 'border-box',
              padding: 0
            }}
          >
            {sending ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <PaperAirplaneIcon className="w-5 h-5" />
            )}
          </button>
        </div>
        <p className="text-xs text-gray-500">
          Press Enter to send, Shift+Enter for new line
        </p>
      </form>
    </div>
  );
};

export default ChannelInput;

